<template>
  <div class="new_homeNotice">
    <div class="new_homeNotice_content" v-show="show">
      <transition name="fade">
        <AnnouncementMessage
          v-if="showAnnounceMessage"
          v-on:closeClick="handleCloseClick"
          v-on:toNotification="toNotification"
        />
      </transition>
      <transition name="fade">
        <Message
          v-if="showNotification"
          :notification="latest_notification"
          v-on:closeClick="handleCloseClick"
          v-on:toNotification="toNotification"
        />
      </transition>
      <transition name="fade">
        <MessageList v-if="showMessageList" @close-click="handleMessgaeListCloseClick" />
      </transition>

      <transition name="fade">
        <DailyReview
          v-if="showDailyReviewCard"
          v-on:share-clicked="shareClicked"
          v-on:memo-removed="deleteMemo"
          v-on:tag-clicked="clickTag"
          v-on:thread-clicked="openThread"
          v-on:add-linked-memo="addLinkedMemo"
          v-on:closeClick="handleCloseClick"
          v-on:toNotify="toNotification"
        />
      </transition>
    </div>
    <FlexCenter @mouseover="handleShowMenu(true)" @mouseleave="handleShowMenu(false)">
      <FlexCenter v-show="showMenu">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t('web_app.homeNotice.daily_tips')"
          placement="left"
          v-if="is_pro && !useSuggestions"
        >
          <CircleBtn @click="toggleDailyReview">
            <svg-icon iconClass="magic3"></svg-icon>
          </CircleBtn>
        </el-tooltip>

        <el-tooltip class="item" effect="dark" :content="$t('web_app.homeNotice.notice_tips')" placement="left">
          <CircleBtn @click="showNotice">
            <svg-icon iconClass="notice"></svg-icon>
          </CircleBtn>
        </el-tooltip>
      </FlexCenter>
      <div
        class="new_homeNotice_btn"
        v-if="!showLottie"
        :class="{
          active: show,
        }"
      >
        <svg-icon :iconClass="iconClass"></svg-icon>
      </div>

      <div class="new_homeNotice_active" v-if="showLottie" @click.stop="toggleNotice">
        <LottieNotice :show-tips="showTips" :handle-tip="handleTip" />
      </div>
    </FlexCenter>
  </div>
</template>
<script>
import Message from './Message.vue'
import DailyReview from './DailyReview.vue'
import emitter from '../../utils/eventbus.js'
import AnnouncementMessage from './AnnouncementMessage.vue'
import logClickEvent from '../../utils/logClickEvent'
import { FlexCenter } from '../UI/Flex'
import { CircleBtn } from '../UI/CircleBtn'
import MessageList from './MessageList.vue'

export default {
  name: 'NewHomeNotice',
  components: {
    Message,
    DailyReview,
    AnnouncementMessage,
    FlexCenter,
    CircleBtn,
    MessageList,
    LottieNotice: () => import('./LottieNotice.vue'),
  },
  data() {
    return {
      user: this.$store.state.me,
      show: false,
      notification: null,
      showDailyReviewAfterTips: false,
      showMenu: false,
      showMessageList: false,
      showNotification: false,
      showAnnounceMessage: false,
      showLottie: false,
      showTips: false,
    }
  },
  computed: {
    handleTip() {
      let tips = ''
      if (this.has_unread_notification) {
        tips = this.$t('homeNotice.active.tips.notification')
      }
      if (this.showAnnouncement) {
        tips = this.$t('homeNotice.active.tips.announcement')
      }
      if ((this.showDailyReviewTips || this.showDailyReviewCard) && !this.useSuggestions) {
        tips = this.$t('homeNotice.active.tips.dailyReview')
      }
      if (
        (this.showDailyReviewTips || this.showDailyReviewCard) &&
        !this.useSuggestions &&
        this.has_unread_notification
      ) {
        tips = this.$t('homeNotice.active.tips.dailyReviewAndNotification')
      }
      if ((this.showDailyReviewTips || this.showDailyReviewCard) && !this.useSuggestions && this.showAnnouncement) {
        tips = this.$t('homeNotice.active.tips.dailyReviewAndAnnouncement')
      }
      if (this.has_unread_notification && this.showAnnouncement) {
        tips = this.$t('homeNotice.active.tips.notificationAndAnnouncement')
      }
      if (
        (this.showDailyReviewTips || this.showDailyReviewCard) &&
        !this.useSuggestions &&
        this.has_unread_notification &&
        this.showAnnouncement
      ) {
        tips = this.$t('homeNotice.active.tips.all')
      }

      return tips
    },
    iconClass() {
      if (this.showDailyReviewCard) {
        return 'magic3'
      } else if (this.showMessageList) {
        return 'notice'
      } else {
        return 'menu'
      }
    },
    // 最新消息
    latest_notification() {
      if (this.$store.state.notifications.length) {
        return this.$store.state.notifications[0]
      }
      return { readed: 1 }
    },
    has_unread_notification() {
      return !this.latest_notification.readed
    },
    progress() {
      return this.$store.getters['dailyReview/progress']
    },
    enableHomepageNotification() {
      return this.$store.getters['dailyReview/enableHomepageNotification']
    },
    autoShow() {
      let show = false
      if (this.has_unread_notification) {
        show = true
      }
      return show
    },
    syncing() {
      return this.$store.state.syncing
    },
    is_pro() {
      return this.$store.getters.is_pro
    },
    dailyReviewList() {
      return this.$store.getters['dailyReview/dailyReviewList']
    },
    showDailyReview() {
      return (
        this.progress == 0 &&
        this.is_pro &&
        (this.enableHomepageNotification == 1 ||
          (this.enableHomepageNotification && this.enableHomepageNotification != 0))
      )
    },
    dailyReviewReminder() {
      return this.$store.getters['dailyReview/dailyReviewReminder']
    },
    showDailyReviewCard() {
      return this.$store.getters['dailyReview/showDailyReviewCard']
    },
    showDailyReviewTips() {
      return this.progress == 0 && this.is_pro && !this.useSuggestions
    },
    shouldClose() {
      return !this.has_unread_notification && !this.showDailyReviewCard && !this.showAnnouncement
    },
    showAnnouncement() {
      return this.$store.getters['announcement/show']
    },
    useSuggestions() {
      return this.$store.getters['dailyReview/useSuggestions']
    },
  },
  methods: {
    markAsRead(callback) {
      this.$api.call('POST', '/notification/' + this.latest_notification.id + '/mark_as_read', {}, (response) => {
        if (response.data && response.data.code === 0) {
          this.$store.commit('setNotificationReaded', this.latest_notification.id)
          if (callback) callback()
        }
      })
    },
    handleAnimation(anim) {
      this.anim = anim
    },
    viewLater() {
      this.togglePopover()
    },

    handleCloseClick() {
      if (this.showAnnounceMessage) {
        this.showAnnounceMessage = false
      }
      if (this.showNotification) {
        this.showNotification = false
      }
      // 关闭 popover ，需要未读消息已读，每日回顾提示关闭，每日回顾卡片关闭
      if (this.shouldClose) {
        this.show = false
        this.showLottie = false
      }
    },

    async toggleNotice() {
      if (this.show) {
        logClickEvent('首页消息提醒', '点击')
        if (this.showDailyReviewTips) {
          await this.$store.dispatch('dailyReview/getDailyReview')
          await this.$store.dispatch('dailyReview/getCurrentReviewMemo')
          await this.$store.dispatch('dailyReview/setShowDailyReviewCard', true)
        }
        if (this.showAnnouncement) {
          this.showAnnounceMessage = true
        }
        if (this.has_unread_notification) {
          this.showNotification = true
        }
      }
    },
    togglePopover() {
      this.show = !this.show
      logClickEvent('首页提醒入口', this.show ? '展开弹窗' : '收起弹窗')
    },
    toNotification(from) {
      this.show = true
      if (this.showAnnounceMessage) {
        // 关闭公告
        this.showAnnounceMessage = false
        if (this.showNotification) {
          // 已读消息
          this.markAsRead(() => {
            this.showNotification = false
          })
        }
      }
      if (this.showNotification) {
        // 关闭消息通知
        this.showNotification = false
        if (this.showAnnounceMessage) {
          this.showAnnounceMessage = false
        }
      }

      if (this.showLottie) {
        // 切换消息通知为已读icon
        this.showLottie = false
      }
      // 关闭回顾
      if (this.showDailyReviewCard) {
        this.$store.dispatch('dailyReview/setShowDailyReviewCard', false)
      }
      // 显示消息列表
      this.showMessageList = true
      logClickEvent('首页快捷菜单-消息通知', '查看全部')
    },
    clickTag(tag) {
      this.$emit('tag-clicked', tag)
    },
    openThread(slug) {
      this.$emit('thread-clicked', slug)
    },
    addLinkedMemo(_memo) {
      this.$emit('add-linked-memo', _memo)
    },
    shareClicked(_memo) {
      this.$emit('share-clicked', _memo)
    },
    deleteMemo(memo) {
      this.$emit('memo-removed', memo)
    },
    pinMemo(memo) {
      this.$emit('memo-pinned', memo)
    },
    unpinMemo(memo) {
      this.$emit('memo-unpinned', memo)
    },
    async init() {
      await this.$store.dispatch('getUserInfo')
      await this.$store.dispatch('loadNotifications')
      await this.$store.dispatch('announcement/getAnnouncement')
      if (this.is_pro) {
        await this.$store.dispatch('dailyReview/getProgress')
      }

      if (this.is_pro && !this.useSuggestions) {
        await this.$store.dispatch('dailyReview/getReviewSetting')
      }

      setTimeout(() => {
        this.display_notification_popup()
      }, 1000)
    },

    display_notification_popup() {
      if (this.show) {
        return
      }
      if (
        (this.progress == 0 &&
          this.dailyReviewReminder == 0 &&
          (this.enableHomepageNotification == 1 ||
            (this.enableHomepageNotification && this.enableHomepageNotification != 0))) ||
        this.showAnnouncement ||
        this.has_unread_notification
      ) {
        this.show = true
        this.showLottie = true
        setTimeout(() => {
          this.showTips = true
        }, 1000)

        setTimeout(() => {
          this.showTips = false
        }, 6000)
        logClickEvent('首页消息提醒', '展示')
      }
    },

    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    async toggleDailyReview() {
      this.toggleMenu()
      await this.$store.dispatch('dailyReview/getDailyReview')
      await this.$store.dispatch('dailyReview/getCurrentReviewMemo')
      this.show = true
      logClickEvent('首页快捷菜单', '每日回顾')
      await this.$store.dispatch('dailyReview/setShowDailyReviewCard', true)
      //this.$store.dispatch('dailyReview/syncProgress', 1)
    },
    showNotice() {
      this.toggleMenu()
      this.show = true
      logClickEvent('首页快捷菜单', '消息通知')
      this.showMessageList = true
    },
    handleShowMenu(show) {
      // 已经是显示状态，不需要再次触发
      if (this.show) {
        return
      }
      if (show && !this.showMenu) {
        logClickEvent('首页快捷菜单', '展开菜单')
      }
      this.showMenu = show
    },
    handleMessgaeListCloseClick() {
      this.showMessageList = false
      this.show = false
    },
  },

  async mounted() {
    if (!this.syncing) {
      this.init()
    }
    emitter.on('sync-finish', async () => {
      this.init()
    })
  },
}
</script>
<style lang="scss" scoped>
.new_homeNotice {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  gap: 10px;
  justify-content: center;
  align-items: flex-end;

  &_content {
    position: relative;
    transition: all 0.6s ease-in-out;
    right: -10px;
    //margin-bottom: 10px;
  }

  &_btn {
    position: static;
    background: var(--noticeBg);
    box-shadow: 0px 0px 40px 0px var(--bigShadow);
    width: 48px;
    height: 48px;
    border-radius: 48px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
    overflow: hidden;
    svg {
      width: 16px;
      height: 16px;
      margin-top: 16px;
      color: #9d9d9d;
    }
    &:hover {
      background: var(--bgGreen);
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
      svg {
        color: var(--memberPlanColor);
      }
    }
  }

  &_active {
    cursor: pointer;
  }

  .active {
    box-shadow: 0px 0px 40px 0px var(--bigShadow);
    background: var(--bgGreen);
    svg {
      color: #fff;
    }
  }
}
</style>
